import { RecipePreparationStep } from '../types';

export function parseRecipeImportNumber(value: unknown): number | null {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;

  let normalized = String(value)
    .trim()
    .replace(/\s|\u00a0/g, '')
    .replace(/₴|грн/gi, '');
  if (!normalized) return null;

  const comma = normalized.lastIndexOf(',');
  const dot = normalized.lastIndexOf('.');
  if (comma >= 0 && dot >= 0) {
    const decimalSeparator = comma > dot ? ',' : '.';
    const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
    normalized = normalized.split(thousandsSeparator).join('');
    if (decimalSeparator === ',') normalized = normalized.replace(',', '.');
  } else if (comma >= 0) {
    normalized = normalized.replace(',', '.');
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function parseRecipePreparationSteps(value: unknown): RecipePreparationStep[] | null {
  if (typeof value !== 'string' || !value.trim()) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    return null;
  }
  if (!Array.isArray(parsed) || parsed.length > 50) return null;
  const steps: RecipePreparationStep[] = [];
  for (const candidate of parsed) {
    if (!candidate || typeof candidate !== 'object') return null;
    const step = candidate as Record<string, unknown>;
    if (typeof step.title !== 'string' || !step.title.trim() || step.title.trim().length > 120) return null;
    if (typeof step.instructions !== 'string' || !step.instructions.trim() || step.instructions.trim().length > 3000) return null;
    const estimatedMinutes = step.estimatedMinutes;
    if (estimatedMinutes !== null && estimatedMinutes !== undefined
      && (!Number.isInteger(estimatedMinutes) || Number(estimatedMinutes) < 0 || Number(estimatedMinutes) > 1440)) return null;
    const photoUrl = step.photoUrl;
    if (photoUrl != null && (typeof photoUrl !== 'string' || !/^\/uploads\/recipe-steps\/[a-f0-9]{32}\.jpg$/i.test(photoUrl))) return null;
    steps.push({
      title: step.title.trim(),
      instructions: step.instructions.trim(),
      estimatedMinutes: estimatedMinutes == null ? null : Number(estimatedMinutes),
      ...(typeof photoUrl === 'string' ? { photoUrl } : {}),
    });
  }
  return steps;
}

export function uniqueRecipeMatch<T>(
  values: T[],
  matches: (value: T) => boolean
): T | undefined {
  const matchesFound = values.filter(matches);
  return matchesFound.length === 1 ? matchesFound[0] : undefined;
}
